// 2026 Topps Chrome Sapphire Star Wars — authored by hand (2026-10-28, release
// day: on sale October 28, 2026 on Topps/EQL, 8 packs x 4 cards per box)
// =============================================================================
// SOURCES: the official Topps checklist PDF ("2026 Sapphire Topps Checklist",
// 82 pp. — pp. 12-82 are blank spreadsheet residue), extracted with macOS
// PDFKit. Like every Topps checklist it names NO parallels. Parallels from
// Checklist Insider's 2026 Sapphire page (names + pack odds) and HobbyMonitor's
// odds breakdown (serials Gold /50, Orange /25, Black /10, Red /5,
// Padparadscha 1/1). The pack odds agree with those serials at ~59,000 packs.
// PRE-RELEASE: specimen-check once product is out.
//
// BASE (1-200) is card-for-card the 2026 Topps Chrome base (src/sets/
// 2026-chrome.js, all 200 names identical). "DEBUT" suffixes stripped; PDFKit
// glued two lines (#127 Imperial Remnant Snowtrooper, auto #156 Stephen
// McKinley Henderson) — split by hand. Base card is unnumbered.
// Aqua/Blue Sapphire Lightning (1:4) is listed UNNUMBERED by both sources, but
// the odds work out to ~74 per card — TODO: it may really be /75 (2023
// Sapphire's Aqua was /75); check a specimen.
//
// HIDDEN GEMS: the base card is the Emerald version; Onyx / Ruby /
// Padparadscha per Checklist Insider. Odds imply ~50 Emerald, ~10 Onyx, ~5 Ruby
// per card — TODO (rule 7): if Emerald is serial-numbered it needs a blank-name
// slot; Onyx / Ruby print runs left null until a specimen shows them.
// KYBER CARVINGS SAPPHIRE: Padparadscha 1/1 only. Odds imply ~25 per card.
//
// AUTOGRAPHS: name = signer, artist = character (2026 Galaxy / Chrome
// convention). CHARACTERS AUTOGRAPHS (182 = Checklist Insider's count) use the
// BASE number for 134 signers plus 48 A- codes (all 48 identical to 2026
// Chrome's A- autos). Red Sapphire /5 + Padparadscha 1/1; base unnumbered
// (odds imply ~16 per signer).
// ⚠️ Topps' numbers disagree with the base character on ten autos, kept AS
// PRINTED on the checklist until a card back shows otherwise (keys are
// immutable once collected): 124 Jason Isaacs / The Grand Inquisitor (base
// 199), 125 Jeremy Allen White / Rotta the Hutt (base 200), 186 Lord Janu
// (base 195), 190 Gerdis (base 189), 191 Lando (base 190), 195 Royce Hemlock
// (base 194), 196 Dedra Meero (base 115), 197 Droopy McCool (base 196), 198
// R2-D2 (base 197), 199 Krrsantan (base 160). Jeremy Allen White was removed
// from Topps' newer 2026 Chrome checklist but is still in this one.
// Fixed: #34 "Runai Scudlen" -> Runai Sculdun (Topps' misspelling, as in 2026
// Chrome); #114 Bronte Carmichael's character given as herself -> Leida Mothma.
// KYBER CARVINGS SAPPHIRE AUTOGRAPHS: Topps' table pairs every code with the
// wrong signer (KCS-DARTH = Mark Hamill / Luke ...), the same column-sort slip
// as 2023 Sapphire's autograph table. Re-paired by the code's character to
// match the Kyber Carvings insert (KCS-DARTH = David Prowse / Darth Vader).
// DUO (22) / TRIPLE (19): identical to 2026 Chrome's duo and triple autos
// (codes, signers, characters). Padparadscha 1/1 only per Checklist Insider
// (HobbyMonitor also mentions a Red Sapphire — unconfirmed). Odds imply ~4
// per card — TODO (rule 7): base may be numbered; no slot until a specimen.
// =============================================================================

export const SETS = [
  {
    id: 'base', type: 'base', title: 'BASE SET — 200 CARDS',
    parallels: [{id:'aqua-blue-sapphire-lightning',name:'Aqua/Blue Sapphire Lightning',print_run:null,color:'#00e5ff'},{id:'gold-sapphire',name:'Gold Sapphire',print_run:50,color:'#f0c040'},{id:'orange-sapphire',name:'Orange Sapphire',print_run:25,color:'#ff9d52'},{id:'black-sapphire',name:'Black Sapphire',print_run:10,color:'#a8a8b4'},{id:'red-sapphire',name:'Red Sapphire',print_run:5,color:'#ff5d5d'},{id:'padparadscha-sapphire',name:'Padparadscha Sapphire',print_run:1,color:'#ff9e80'}],
    cards: [
      {n:'1', name:'Obi-Wan Kenobi', artist:null},
      {n:'2', name:'Lezine', artist:null},
      {n:'3', name:'Chopper', artist:null},
      {n:'4', name:'Devon Izara', artist:null},
      {n:'5', name:'Wizzich Mozzer', artist:null},
      {n:'6', name:'General Maximilian Veers', artist:null},
      {n:'7', name:'Rune Haako', artist:null},
      {n:'8', name:'Tusken Raider Warrior', artist:null},
      {n:'9', name:'Baylan Skoll', artist:null},
      {n:'10', name:'Captain Kaido', artist:null},
      {n:'11', name:'Freck', artist:null},
      {n:'12', name:'Clone Captain Rex', artist:null},
      {n:'13', name:'Sy Snootles', artist:null},
      {n:'14', name:'Chewbacca', artist:null},
      {n:'15', name:'Rabé', artist:null},
      {n:'16', name:'Hamato Xiono', artist:null},
      {n:'17', name:'Ahsoka Tano', artist:null},
      {n:'18', name:'Davo Sculdun', artist:null},
      {n:'19', name:'At Attin frogdog', artist:null},
      {n:'20', name:'Icarus', artist:null},
      {n:'21', name:'Ezra Bridger', artist:null},
      {n:'22', name:'General Hux', artist:null},
      {n:'23', name:'Ben Quadinaros', artist:null},
      {n:'24', name:'Bo-Katan Kryze', artist:null},
      {n:'25', name:'Looti Vario', artist:null},
      {n:'26', name:'Sergeant Heert', artist:null},
      {n:'27', name:'Mace Windu', artist:null},
      {n:'28', name:'Nooma', artist:null},
      {n:'29', name:'General Grievous', artist:null},
      {n:'30', name:'Maz Kanata', artist:null},
      {n:'31', name:'Rey', artist:null},
      {n:'32', name:'Grogu', artist:null},
      {n:'33', name:'Grand Admiral Thrawn', artist:null},
      {n:'34', name:'Runai Sculdun', artist:null},
      {n:'35', name:'Hutt Sister', artist:null},
      {n:'36', name:'Ralakili', artist:null},
      {n:'37', name:'Mace Windu', artist:null},
      {n:'38', name:'Poe Dameron', artist:null},
      {n:'39', name:'Moff Gideon', artist:null},
      {n:'40', name:'Hera Syndulla', artist:null},
      {n:'41', name:'Senator Oran', artist:null},
      {n:'42', name:'The Armorer', artist:null},
      {n:'43', name:'Qi\'ra', artist:null},
      {n:'44', name:'Yoda', artist:null},
      {n:'45', name:'BB-8', artist:null},
      {n:'46', name:'D-O', artist:null},
      {n:'47', name:'The Mandalorian', artist:null},
      {n:'48', name:'Sabine Wren', artist:null},
      {n:'49', name:'Supervisor Lonni Jung', artist:null},
      {n:'50', name:'Vult Skerris', artist:null},
      {n:'51', name:'Dryden Vos', artist:null},
      {n:'52', name:'Anakin Skywalker', artist:null},
      {n:'53', name:'Finn', artist:null},
      {n:'54', name:'Colonel Aftab Ackbar', artist:null},
      {n:'55', name:'Zeb Orrelios', artist:null},
      {n:'56', name:'Shin Hati', artist:null},
      {n:'57', name:'Kylo Ren', artist:null},
      {n:'58', name:'Kanan Jarrus', artist:null},
      {n:'59', name:'Sidon Ithano', artist:null},
      {n:'60', name:'Klatooinian Crime Boss', artist:null},
      {n:'61', name:'Eedy Karn', artist:null},
      {n:'62', name:'Babu Frik', artist:null},
      {n:'63', name:'Cobb Vanth', artist:null},
      {n:'64', name:'Morgan Elsbeth', artist:null},
      {n:'65', name:'Ghorman Spider', artist:null},
      {n:'66', name:'Emperor Palpatine', artist:null},
      {n:'67', name:'Sergeant Gharial', artist:null},
      {n:'68', name:'Colonel Ward', artist:null},
      {n:'69', name:'Bobbajo', artist:null},
      {n:'70', name:'Haja Estree', artist:null},
      {n:'71', name:'Syril Karn', artist:null},
      {n:'72', name:'Commissioner Helgait', artist:null},
      {n:'73', name:'Erskin Semaj', artist:null},
      {n:'74', name:'Jyn Erso', artist:null},
      {n:'75', name:'Hype Fazon', artist:null},
      {n:'76', name:'Rook Kast', artist:null},
      {n:'77', name:'Scorn', artist:null},
      {n:'78', name:'Bix Caleen', artist:null},
      {n:'79', name:'Kuiil', artist:null},
      {n:'80', name:'Captain Enoch', artist:null},
      {n:'81', name:'Stekan Sculdun', artist:null},
      {n:'82', name:'Chirrut Îmwe', artist:null},
      {n:'83', name:'Han Solo', artist:null},
      {n:'84', name:'Imperial Inquisitor', artist:null},
      {n:'85', name:'Lieutenant Connix', artist:null},
      {n:'86', name:'Rose Tico', artist:null},
      {n:'87', name:'The Duchess of Plazir', artist:null},
      {n:'88', name:'Great Mother Lakesis', artist:null},
      {n:'89', name:'Drash', artist:null},
      {n:'90', name:'Jan Dodonna', artist:null},
      {n:'91', name:'Luke Skywalker', artist:null},
      {n:'92', name:'Niro', artist:null},
      {n:'93', name:'Captain Phasma', artist:null},
      {n:'94', name:'Jedi Master Sol', artist:null},
      {n:'95', name:'Omera', artist:null},
      {n:'96', name:'Vel Sartha', artist:null},
      {n:'97', name:'Kleya Marki', artist:null},
      {n:'98', name:'Huyang', artist:null},
      {n:'99', name:'Moff Tarkin', artist:null},
      {n:'100', name:'Bardi', artist:null},
      {n:'101', name:'Asajj Ventress', artist:null},
      {n:'102', name:'Supreme Leader Snoke', artist:null},
      {n:'103', name:'The Stranger', artist:null},
      {n:'104', name:'Captain Gilad Pellaeon', artist:null},
      {n:'105', name:'Cassian Andor', artist:null},
      {n:'106', name:'Pix the Tooka', artist:null},
      {n:'107', name:'Jace Rucklin', artist:null},
      {n:'108', name:'Ponda Baba', artist:null},
      {n:'109', name:'Raxshir', artist:null},
      {n:'110', name:'Noti', artist:null},
      {n:'111', name:'Jedi Master Indara', artist:null},
      {n:'112', name:'Hutt Brother', artist:null},
      {n:'113', name:'Mon Mothma', artist:null},
      {n:'114', name:'Leida Mothma', artist:null},
      {n:'115', name:'Dedra Meero', artist:null},
      {n:'116', name:'Owen Lars', artist:null},
      {n:'117', name:'Yaddle', artist:null},
      {n:'118', name:'Lovey', artist:null},
      {n:'119', name:'Massiff', artist:null},
      {n:'120', name:'Elia Kane', artist:null},
      {n:'121', name:'K-2SO', artist:null},
      {n:'122', name:'General Draven', artist:null},
      {n:'123', name:'Jod Na Nawood', artist:null},
      {n:'124', name:'Count Dooku', artist:null},
      {n:'125', name:'Bossk', artist:null},
      {n:'126', name:'Dobbu Scay', artist:null},
      {n:'127', name:'Imperial Remnant Snowtrooper', artist:null},
      {n:'128', name:'Ranzar "Ran" Malk', artist:null},
      {n:'129', name:'Luthen Rael', artist:null},
      {n:'130', name:'Bail Organa', artist:null},
      {n:'131', name:'Neel', artist:null},
      {n:'132', name:'Padmé Amidala', artist:null},
      {n:'133', name:'Zorii Bliss', artist:null},
      {n:'134', name:'Admiral Ackbar', artist:null},
      {n:'135', name:'Embo', artist:null},
      {n:'136', name:'Jawa', artist:null},
      {n:'137', name:'Saw Gerrera', artist:null},
      {n:'138', name:'Cinta Kaz', artist:null},
      {n:'139', name:'SM-33', artist:null},
      {n:'140', name:'Lyco Strata', artist:null},
      {n:'141', name:'Master Eeko-Dio Daki', artist:null},
      {n:'142', name:'Tallie Lintra', artist:null},
      {n:'143', name:'8D8', artist:null},
      {n:'144', name:'Greef Karga', artist:null},
      {n:'145', name:'Jabba the Hutt', artist:null},
      {n:'146', name:'Maul', artist:null},
      {n:'147', name:'Beela', artist:null},
      {n:'148', name:'Taun We', artist:null},
      {n:'149', name:'BDX Droid', artist:null},
      {n:'150', name:'Captain Peavey', artist:null},
      {n:'151', name:'Jedi Padawan Jecki Lon', artist:null},
      {n:'152', name:'Dreena', artist:null},
      {n:'153', name:'Supervisor Lagret', artist:null},
      {n:'154', name:'Beef', artist:null},
      {n:'155', name:'Luminara Unduli', artist:null},
      {n:'156', name:'Gatori', artist:null},
      {n:'157', name:'Captain Canady', artist:null},
      {n:'158', name:'Omega', artist:null},
      {n:'159', name:'Samm', artist:null},
      {n:'160', name:'Krrsantan', artist:null},
      {n:'161', name:'Spybot', artist:null},
      {n:'162', name:'Barriss Offee', artist:null},
      {n:'163', name:'B-1 Mercenary Droid', artist:null},
      {n:'164', name:'Jar Jar Binks', artist:null},
      {n:'165', name:'Boba Fett', artist:null},
      {n:'166', name:'Enza Rylanz', artist:null},
      {n:'167', name:'Clem Andor', artist:null},
      {n:'168', name:'Bubbles', artist:null},
      {n:'169', name:'C-3PO', artist:null},
      {n:'170', name:'Aayla Secura', artist:null},
      {n:'171', name:'Darth Maul', artist:null},
      {n:'172', name:'Cad Bane', artist:null},
      {n:'173', name:'Perrin Fertha', artist:null},
      {n:'174', name:'B2EMO', artist:null},
      {n:'175', name:'L3-37', artist:null},
      {n:'176', name:'Darth Vader', artist:null},
      {n:'177', name:'Plo Koon', artist:null},
      {n:'178', name:'Qui-Gon Jinn', artist:null},
      {n:'179', name:'Fennec Shand', artist:null},
      {n:'180', name:'Carro Rylanz', artist:null},
      {n:'181', name:'Brander Lawson', artist:null},
      {n:'182', name:'Hugo Durant', artist:null},
      {n:'183', name:'Leia Organa', artist:null},
      {n:'184', name:'Even Piell', artist:null},
      {n:'185', name:'Captain Typho', artist:null},
      {n:'186', name:'B-2 Mercenary Droid', artist:null},
      {n:'187', name:'Oathkeeper', artist:null},
      {n:'188', name:'Keibu', artist:null},
      {n:'189', name:'Gerdis', artist:null},
      {n:'190', name:'Lando Calrissian', artist:null},
      {n:'191', name:'Eleventh Brother', artist:null},
      {n:'192', name:'Vane', artist:null},
      {n:'193', name:'Mrs. Ikk', artist:null},
      {n:'194', name:'Dr. Royce Hemlock', artist:null},
      {n:'195', name:'Lord Janu', artist:null},
      {n:'196', name:'Droopy McCool', artist:null},
      {n:'197', name:'R2-D2', artist:null},
      {n:'198', name:'Oppo Rancisis', artist:null},
      {n:'199', name:'The Grand Inquisitor', artist:null},
      {n:'200', name:'Rotta the Hutt', artist:null},
    ],
  },
  {
    id: 'hidden-gems', type: 'insert', title: 'HIDDEN GEMS — 5 CARDS',
    parallels: [{id:'onyx',name:'Onyx',print_run:null,color:'#b8b8c4'},{id:'ruby',name:'Ruby',print_run:null,color:'#ff6b7a'},{id:'padparadscha',name:'Padparadscha',print_run:1,color:'#ff9e80'}],
    cards: [
      {n:'HG-1', name:'Han Solo', artist:null},
      {n:'HG-2', name:'Leia Organa', artist:null},
      {n:'HG-3', name:'Grand Admiral Thrawn', artist:null},
      {n:'HG-4', name:'Kylo Ren', artist:null},
      {n:'HG-5', name:'Yoda', artist:null},
    ],
  },
  {
    id: 'kyber-carvings-sapphire', type: 'insert', title: 'KYBER CARVINGS SAPPHIRE — 5 CARDS',
    parallels: [{id:'padparadscha-sapphire',name:'Padparadscha Sapphire',print_run:1,color:'#ff9e80'}],
    cards: [
      {n:'KCS-DARTH', name:'Darth Vader', artist:null},
      {n:'KCS-OBI', name:'Obi-Wan Kenobi', artist:null},
      {n:'KCS-MACE', name:'Mace Windu', artist:null},
      {n:'KCS-LUKE', name:'Luke Skywalker', artist:null},
      {n:'KCS-MAUL', name:'Darth Maul', artist:null},
    ],
  },
  {
    id: 'autograph-cards', type: 'auto', title: 'CHARACTERS AUTOGRAPHS — 182 CARDS',
    parallels: [{id:'red-sapphire',name:'Red Sapphire',print_run:5,color:'#ff5d5d'},{id:'padparadscha-sapphire',name:'Padparadscha Sapphire',print_run:1,color:'#ff9e80'}],
    cards: [
      {n:'1', name:'Ewan McGregor', artist:'Obi-Wan Kenobi'},
      {n:'2', name:'Thierry Godard', artist:'Lezine'},
      {n:'4', name:'Gideon Adlon', artist:'Devon Izara'},
      {n:'6', name:'Julian Glover', artist:'General Maximilian Veers'},
      {n:'8', name:'Joanna Bennett', artist:'Tusken Raider Warrior'},
      {n:'10', name:'Jonjo O\'Neill', artist:'Captain Kaido'},
      {n:'11', name:'Zach Braff', artist:'Freck'},
      {n:'12', name:'Dee Bradley Baker', artist:'Clone Captain Rex'},
      {n:'13', name:'Mike Quinn', artist:'Sy Snootles'},
      {n:'15', name:'Karol Cristina da Silva', artist:'Rabé'},
      {n:'16', name:'Nelson Lee', artist:'Hamato Xiono'},
      {n:'17', name:'Rosario Dawson', artist:'Ahsoka Tano'},
      {n:'18', name:'Richard Dillane', artist:'Davo Sculdun'},
      {n:'20', name:'Steve Blum', artist:'Icarus'},
      {n:'21', name:'Eman Esfandi', artist:'Ezra Bridger'},
      {n:'22', name:'Domhnall Gleeson', artist:'General Hux'},
      {n:'24', name:'Katee Sackhoff', artist:'Bo-Katan Kryze'},
      {n:'25', name:'Chris Diamantopoulos', artist:'Looti Vario'},
      {n:'26', name:'Jacob James Beswick', artist:'Sergeant Heert'},
      {n:'27', name:'TC Carson', artist:'Mace Windu'},
      {n:'28', name:'Geneva Carr', artist:'Nooma'},
      {n:'29', name:'Matthew Wood', artist:'General Grievous'},
      {n:'30', name:'Lupita Nyong\'o', artist:'Maz Kanata'},
      {n:'31', name:'Daisy Ridley', artist:'Rey'},
      {n:'33', name:'Lars Mikkelsen', artist:'Grand Admiral Thrawn'},
      {n:'34', name:'Rosalind Halstead', artist:'Runai Sculdun'},
      {n:'36', name:'Clint Howard', artist:'Ralakili'},
      {n:'37', name:'Samuel L. Jackson', artist:'Mace Windu'},
      {n:'38', name:'Oscar Isaac', artist:'Poe Dameron'},
      {n:'39', name:'Giancarlo Esposito', artist:'Moff Gideon'},
      {n:'40', name:'Mary Elizabeth Winstead', artist:'Hera Syndulla'},
      {n:'41', name:'Raphael Roger Levy', artist:'Senator Oran'},
      {n:'42', name:'Emily Swallow', artist:'The Armorer'},
      {n:'43', name:'Emilia Clarke', artist:'Qi\'ra'},
      {n:'46', name:'Lynn Robertson Bruce', artist:'D-O'},
      {n:'47', name:'Pedro Pascal', artist:'The Mandalorian'},
      {n:'48', name:'Natasha Liu Bordizzo', artist:'Sabine Wren'},
      {n:'49', name:'Robert Emms', artist:'Supervisor Lonni Jung'},
      {n:'50', name:'Mario Vernazza', artist:'Vult Skerris'},
      {n:'51', name:'Paul Bettany', artist:'Dryden Vos'},
      {n:'52', name:'Hayden Christensen', artist:'Anakin Skywalker'},
      {n:'53', name:'John Boyega', artist:'Finn'},
      {n:'56', name:'Ivanna Sakhno', artist:'Shin Hati'},
      {n:'57', name:'Adam Driver', artist:'Kylo Ren'},
      {n:'58', name:'Freddie Prinze Jr.', artist:'Kanan Jarrus'},
      {n:'59', name:'Dee Tails', artist:'Sidon Ithano'},
      {n:'60', name:'Phil LaMarr', artist:'Klatooinian Crime Boss'},
      {n:'61', name:'Kathryn Hunter', artist:'Eedy Karn'},
      {n:'62', name:'Shirley Henderson', artist:'Babu Frik'},
      {n:'63', name:'Timothy Olyphant', artist:'Cobb Vanth'},
      {n:'64', name:'Diana Lee Inosanto', artist:'Morgan Elsbeth'},
      {n:'66', name:'Ian McDiarmid', artist:'Emperor Palpatine'},
      {n:'69', name:'Aidan Cook', artist:'Bobbajo'},
      {n:'71', name:'Kyle Soller', artist:'Syril Karn'},
      {n:'72', name:'Christopher Lloyd', artist:'Commissioner Helgait'},
      {n:'74', name:'Felicity Jones', artist:'Jyn Erso'},
      {n:'76', name:'Vanessa Marshall', artist:'Rook Kast'},
      {n:'78', name:'Adria Arjona', artist:'Bix Caleen'},
      {n:'79', name:'Nick Nolte', artist:'Kuiil'},
      {n:'80', name:'Wes Chatham', artist:'Captain Enoch'},
      {n:'81', name:'Finley Glasgow', artist:'Stekan Sculdun'},
      {n:'83', name:'Harrison Ford', artist:'Han Solo'},
      {n:'85', name:'Billie Lourd', artist:'Lieutenant Connix'},
      {n:'86', name:'Kelly Marie Tran', artist:'Rose Tico'},
      {n:'87', name:'Lizzo', artist:'The Duchess of Plazir'},
      {n:'89', name:'Sophie Thatcher', artist:'Drash'},
      {n:'90', name:'Ian McElhinney', artist:'Jan Dodonna'},
      {n:'91', name:'Mark Hamill', artist:'Luke Skywalker'},
      {n:'92', name:'Artt Butler', artist:'Niro'},
      {n:'93', name:'Gwendoline Christie', artist:'Captain Phasma'},
      {n:'94', name:'Lee Jung-jae', artist:'Jedi Master Sol'},
      {n:'95', name:'Julia Jones', artist:'Omera'},
      {n:'96', name:'Faye Marsay', artist:'Vel Sartha'},
      {n:'97', name:'Elizabeth Dulau', artist:'Kleya Marki'},
      {n:'98', name:'David Tennant', artist:'Huyang'},
      {n:'100', name:'Benjamin Norris', artist:'Bardi'},
      {n:'101', name:'Nikka Futterman', artist:'Asajj Ventress'},
      {n:'102', name:'Andy Serkis', artist:'Supreme Leader Snoke'},
      {n:'103', name:'Manny Jacinto', artist:'The Stranger'},
      {n:'104', name:'Xander Berkeley', artist:'Captain Gilad Pellaeon'},
      {n:'105', name:'Diego Luna', artist:'Cassian Andor'},
      {n:'107', name:'Elijah Wood', artist:'Jace Rucklin'},
      {n:'111', name:'Carrie-Anne Moss', artist:'Jedi Master Indara'},
      {n:'113', name:'Genevieve O\'Reilly', artist:'Mon Mothma'},
      {n:'114', name:'Bronte Carmichael', artist:'Leida Mothma'},
      {n:'117', name:'Bryce Dallas Howard', artist:'Yaddle'},
      {n:'120', name:'Katy O\'Brian', artist:'Elia Kane'},
      {n:'121', name:'Alan Tudyk', artist:'K-2SO'},
      {n:'122', name:'Alistair Petrie', artist:'General Draven'},
      {n:'123', name:'Jude Law', artist:'Jod Na Nawood'},
      {n:'124', name:'Jason Isaacs', artist:'The Grand Inquisitor'},
      {n:'125', name:'Jeremy Allen White', artist:'Rotta the Hutt'},
      {n:'128', name:'Mark Boone Jr.', artist:'Ranzar Malk'},
      {n:'129', name:'Stellan Skarsgård', artist:'Luthen Rael'},
      {n:'130', name:'Benjamin Bratt', artist:'Bail Organa'},
      {n:'132', name:'Natalie Portman', artist:'Padmé Amidala'},
      {n:'133', name:'Keri Russell', artist:'Zorii Bliss'},
      {n:'134', name:'Tim Rose', artist:'Admiral Ackbar'},
      {n:'136', name:'Leilani Shiu', artist:'Jawa'},
      {n:'137', name:'Forest Whitaker', artist:'Saw Gerrera'},
      {n:'138', name:'Varada Sethu', artist:'Cinta Kaz'},
      {n:'139', name:'Nick Frost', artist:'SM-33'},
      {n:'140', name:'Lane Factor', artist:'Lyco Strata'},
      {n:'141', name:'Dennis Haysbert', artist:'Master Eeko-Dio Daki'},
      {n:'142', name:'Hermione Corfield', artist:'Tallie Lintra'},
      {n:'145', name:'David Barclay', artist:'Jabba the Hutt'},
      {n:'146', name:'Sam Witwer', artist:'Maul'},
      {n:'148', name:'Rena Owen', artist:'Taun We'},
      {n:'151', name:'Dafne Keen', artist:'Jedi Padawan Jecki Lon'},
      {n:'154', name:'Dominic Burgess', artist:'Beef'},
      {n:'156', name:'Stephen McKinley Henderson', artist:'Gatori'},
      {n:'158', name:'Michelle Ang', artist:'Omega'},
      {n:'161', name:'David W. Collins', artist:'Spybot'},
      {n:'162', name:'Nalini Krishan', artist:'Barriss Offee'},
      {n:'164', name:'Ahmed Best', artist:'Jar Jar Binks'},
      {n:'165', name:'Temuera Morrison', artist:'Boba Fett'},
      {n:'167', name:'Gary Beadle', artist:'Clem Andor'},
      {n:'169', name:'Anthony Daniels', artist:'C-3PO'},
      {n:'171', name:'Ray Park', artist:'Darth Maul'},
      {n:'173', name:'Alastair Mackenzie', artist:'Perrin Fertha'},
      {n:'176', name:'David Prowse', artist:'Darth Vader'},
      {n:'179', name:'Ming-Na Wen', artist:'Fennec Shand'},
      {n:'180', name:'Richard Sammel', artist:'Carro Rylanz'},
      {n:'183', name:'Carrie Fisher', artist:'Leia Organa'},
      {n:'184', name:'Blair Bess', artist:'Even Piell'},
      {n:'186', name:'Jonny Coyne', artist:'Lord Janu'},
      {n:'190', name:'Sam Gilroy', artist:'Gerdis'},
      {n:'191', name:'Billy Dee Williams', artist:'Lando Calrissian'},
      {n:'192', name:'Marti Matulis', artist:'Vane'},
      {n:'195', name:'Jimmi Simpson', artist:'Royce Hemlock'},
      {n:'196', name:'Denise Gough', artist:'Dedra Meero'},
      {n:'197', name:'Deep Roy', artist:'Droopy McCool'},
      {n:'198', name:'Jimmy Vee', artist:'R2-D2'},
      {n:'199', name:'Carey Jones', artist:'Krrsantan'},
      {n:'A-AE', name:'Ashley Eckstein', artist:'Ahsoka Tano'},
      {n:'A-ALAW', name:'Amanda Lawrence', artist:'Commander D\'acy'},
      {n:'A-ALD', name:'Alden Ehrenreich', artist:'Han Solo'},
      {n:'A-AMY', name:'Amy Sedaris', artist:'Peli Motto'},
      {n:'A-ANP', name:'Angelique Perrin', artist:'Adi Gallia'},
      {n:'A-BAKE', name:'Tom Baker', artist:'Bendu'},
      {n:'A-BDT', name:'Benicio del Toro', artist:'DJ'},
      {n:'A-BRU', name:'Bruce Spence', artist:'Tion Medon'},
      {n:'A-BVE', name:'Brian Vernel', artist:'Bala-Tik'},
      {n:'A-CB', name:'Clancy Brown', artist:'Ryder Azadi'},
      {n:'A-CBL', name:'Claudia Black', artist:'Klothow'},
      {n:'A-CSO', name:'Marton Csokas', artist:'Poggle the Lesser'},
      {n:'A-DD', name:'Dawn Dininger', artist:'Lieutenant Beyta'},
      {n:'A-DER', name:'Laura Dern', artist:'Amilyn Holdo'},
      {n:'A-DISK', name:'Ben Diskin', artist:'AZI-3'},
      {n:'A-DMO', name:'Dominic Monaghan', artist:'Beaumont Kin'},
      {n:'A-DOY', name:'David Oyelowo', artist:'Alexsandr Kallus'},
      {n:'A-DUS', name:'Riz Ahmed', artist:'Bodhi Rook'},
      {n:'A-ERI', name:'Cynthia Erivo', artist:'Jedi Master Kratu'},
      {n:'A-FON', name:'Gabriel Fonseca', artist:'Duke Kayo Organa'},
      {n:'A-FSH', name:'Fiona Shaw', artist:'Maarva Andor'},
      {n:'A-GG', name:'Greg Grunberg', artist:'Snap Wexley'},
      {n:'A-GTA', name:'George Takei', artist:'Lok Durd'},
      {n:'A-GTO', name:'Gina Torres', artist:'Ketsu Onyo'},
      {n:'A-HQU', name:'Hugh Quarshie', artist:'Captain Panaka'},
      {n:'A-JAKEL', name:'Jake Lloyd', artist:'Anakin Skywalker'},
      {n:'A-JSP', name:'Jason Spisak', artist:'Lux Bonteri'},
      {n:'A-KATK', name:'Katy Kartwheel', artist:'Rio Durant'},
      {n:'A-KKN', name:'Keira Knightley', artist:'Sabé'},
      {n:'A-LBO', name:'Lee Boardman', artist:'Kravas Drezzer'},
      {n:'A-LL', name:'Lucy Liu', artist:'Bandit Leader'},
      {n:'A-MOS', name:'Moses Ingram', artist:'Reva'},
      {n:'A-PEGG', name:'Simon Pegg', artist:'Unkar Plutt'},
      {n:'A-PM', name:'Peter Mayhew', artist:'Chewbacca'},
      {n:'A-ROD', name:'Al Rodrigo', artist:'Quinlan Vos'},
      {n:'A-RON', name:'Ron Howard', artist:'Solo: A Star Wars Story'},
      {n:'A-ROP', name:'Ron Perlman', artist:'Gha Nachkt'},
      {n:'A-RUP', name:'Rupert Friend', artist:'The Grand Inquisitor'},
      {n:'A-SEB', name:'Sebastian Armesto', artist:'Lieutenant Mitaka'},
      {n:'A-SMG', name:'Sarah Michelle Gellar', artist:'Seventh Sister'},
      {n:'A-SPIN', name:'Brent Spiner', artist:'Gall Trayvis'},
      {n:'A-TAT', name:'Fred Tatasciore', artist:'Captain Brutus'},
      {n:'A-TKA', name:'Taika Waititi', artist:'IG-11'},
      {n:'A-TNEW', name:'Thandiwe Newton', artist:'Val'},
      {n:'A-TVAL', name:'Tasia Valenza', artist:'Shaak Ti'},
      {n:'A-VR', name:'Vinette Robinson', artist:'Wrobie Tyce'},
      {n:'A-WANDA', name:'Wanda Sykes', artist:'Phee Genoa'},
      {n:'A-WER', name:'Werner Herzog', artist:'The Client'},
    ],
  },
  {
    id: 'kyber-carvings-sapphire-autographs', type: 'auto', title: 'KYBER CARVINGS SAPPHIRE AUTOGRAPHS — 5 CARDS',
    parallels: [{id:'padparadscha-sapphire',name:'Padparadscha Sapphire',print_run:1,color:'#ff9e80'}],
    cards: [
      {n:'KCS-DARTH', name:'David Prowse', artist:'Darth Vader'},
      {n:'KCS-OBI', name:'Ewan McGregor', artist:'Obi-Wan Kenobi'},
      {n:'KCS-MACE', name:'Samuel L. Jackson', artist:'Mace Windu'},
      {n:'KCS-LUKE', name:'Mark Hamill', artist:'Luke Skywalker'},
      {n:'KCS-MAUL', name:'Ray Park', artist:'Darth Maul'},
    ],
  },
  {
    id: 'duo-autographs', type: 'auto', title: 'DUO AUTOGRAPHS — 22 CARDS',
    parallels: [{id:'padparadscha-sapphire',name:'Padparadscha Sapphire',print_run:1,color:'#ff9e80'}],
    cards: [
      {n:'DUO-66', name:'Temuera Morrison / Ian McDiarmid', artist:'Clone Commander Cody / Darth Sidious'},
      {n:'DUO-AD', name:'Diego Luna / Alan Tudyk', artist:'Cassian Andor / K-2SO'},
      {n:'DUO-AJ', name:'Alden Ehrenreich / Joonas Suotamo', artist:'Han Solo / Chewbacca'},
      {n:'DUO-BD', name:'Daisy Ridley / Billy Dee Williams', artist:'Rey / Lando Calrissian'},
      {n:'DUO-BG', name:'Gwendoline Christie / Benicio del Toro', artist:'Captain Phasma / DJ'},
      {n:'DUO-DP', name:'Peter Mayhew / David Prowse', artist:'Chewbacca / Darth Vader'},
      {n:'DUO-DROIDS', name:'Anthony Daniels / Jimmy Vee', artist:'C-3PO / R2-D2'},
      {n:'DUO-DS', name:'Denise Gough / Stellan Skarsgård', artist:'Dedra Meero / Luthen Rael'},
      {n:'DUO-FETT', name:'Temuera Morrison / Daniel Logan', artist:'Jango Fett / Boba Fett'},
      {n:'DUO-FG', name:'Felicity Jones / Genevieve O\'Reilly', artist:'Jyn Erso / Mon Mothma'},
      {n:'DUO-HE', name:'Hayden Christensen / Ewan McGregor', artist:'Darth Vader / Obi-Wan Kenobi'},
      {n:'DUO-JAKKU', name:'Daisy Ridley / Simon Pegg', artist:'Rey / Unkar Plutt'},
      {n:'DUO-JH', name:'Jeremy Bulloch / Harrison Ford', artist:'Boba Fett / Han Solo'},
      {n:'DUO-JM', name:'Jennifer Beals / Ming-Na Wen', artist:'Garsa Fwip / Fennec Shand'},
      {n:'DUO-JN', name:'Jake Lloyd / Natalie Portman', artist:'Anakin Skywalker / Padmé Amidala'},
      {n:'DUO-KI', name:'Keira Knightley / Ian McDiarmid', artist:'Sabé / Senator Palpatine'},
      {n:'DUO-LM', name:'Lee Jung-jae / Manny Jacinto', artist:'Jedi Master Sol / The Stranger'},
      {n:'DUO-NA', name:'Natalie Portman / Anthony Daniels', artist:'Padmé Amidala / C-3PO'},
      {n:'DUO-SE', name:'Elizabeth Dulau / Stellan Skarsgård', artist:'Kleya Marki / Luthen Rael'},
      {n:'DUO-SI', name:'Ian McDiarmid / Samuel L. Jackson', artist:'Supreme Chancellor Palpatine / Mace Windu'},
      {n:'DUO-SOLO', name:'Adam Driver / Harrison Ford', artist:'Kylo Ren / Han Solo'},
      {n:'DUO-TG', name:'Taika Waititi / Giancarlo Esposito', artist:'IG-11 / Moff Gideon'},
    ],
  },
  {
    id: 'triple-autographs', type: 'auto', title: 'TRIPLE AUTOGRAPHS — 19 CARDS',
    parallels: [{id:'padparadscha-sapphire',name:'Padparadscha Sapphire',print_run:1,color:'#ff9e80'}],
    cards: [
      {n:'TRIP-DAK', name:'Anton Lesser / Kyle Soller / Denise Gough', artist:'Major Partagaz / Syril Karn / Dedra Meero'},
      {n:'TRIP-DEG', name:'Diego Luna / Elizabeth Dulau / Genevieve O\'Reilly', artist:'Cassian Andor / Kleya Marki / Mon Mothma'},
      {n:'TRIP-DFT', name:'Dee Bradley Baker / Taylor Gray / Freddie Prinze Jr.', artist:'Rex / Ezra Bridger / Kanan Jarrus'},
      {n:'TRIP-DJJ', name:'Daisy Ridley / Joonas Suotamo / Jimmy Vee', artist:'Rey / Chewbacca / R2-D2'},
      {n:'TRIP-DKK', name:'Kyle Soller / Kathryn Hunter / Denise Gough', artist:'Syril Karn / Eedy Karn / Dedra Meero'},
      {n:'TRIP-EAP', name:'Alden Ehrenreich / Emilia Clarke / Paul Bettany', artist:'Han Solo / Qi\'ra / Dryden Vos'},
      {n:'TRIP-GAB', name:'Bronte Carmichael / Genevieve O\'Reilly / Alastair Mackenzie', artist:'Leida Mothma / Mon Mothma / Perrin Fertha'},
      {n:'TRIP-GAM', name:'Mary Elizabeth Winstead / Genevieve O\'Reilly / Anthony Daniels', artist:'Hera Syndulla / Mon Mothma / C-3PO'},
      {n:'TRIP-IRN', name:'Ian McDiarmid / Ray Park / Natalie Portman', artist:'Darth Sidious / Darth Maul / Padmé Amidala'},
      {n:'TRIP-KME', name:'Mercedes Varnado / Katee Sackhoff / Emily Swallow', artist:'Koska Reeves / Bo-Katan Kryze / The Armorer'},
      {n:'TRIP-KNJ', name:'Nick Frost / Jude Law / Kyriana Kratter', artist:'SM-33 / Jod Na Nawood / KB'},
      {n:'TRIP-OLK', name:'Keri Russell / Oscar Isaac / Lynn Robertson Bruce', artist:'Zorii Bliss / Poe Dameron / D-O'},
      {n:'TRIP-RDN', name:'Rosario Dawson / David Tennant / Natasha Liu Bordizzo', artist:'Ahsoka Tano / Huyang / Sabine Wren'},
      {n:'TRIP-RFF', name:'Riz Ahmed / Forest Whitaker / Felicity Jones', artist:'Bodhi Rook / Saw Gerrera / Jyn Erso'},
      {n:'TRIP-SDT', name:'Samuel L. Jackson / Temuera Morrison / Daniel Logan', artist:'Mace Windu / Jango Fett / Boba Fett'},
      {n:'TRIP-SKD', name:'Shirley Henderson / Keri Russell / Dave Chapman', artist:'Babu Frik / Zorii Bliss / BB-8'},
      {n:'TRIP-SLD', name:'Dave Chapman / Lynn Robertson Bruce / Shirley Henderson', artist:'BB-8 / D-O / Babu Frik'},
      {n:'TRIP-SMC', name:'Sophie Thatcher / Carey Jones / Ming-Na Wen', artist:'Drash / Krrsantan / Fennec Shand'},
      {n:'TRIP-YAVIN', name:'Mark Hamill / Harrison Ford / Peter Mayhew', artist:'Luke Skywalker / Han Solo / Chewbacca'},
    ],
  },
];
